import { DialogComponent } from '@theme/dialog';

class SizeGuideDialog extends DialogComponent {}

if (!customElements.get('size-guide-dialog')) {
  customElements.define('size-guide-dialog', SizeGuideDialog);
}

function initSizeGuideControls() {
  const containers = document.querySelectorAll('[data-size-guide-content]');
  containers.forEach((container) => {
    if (container.dataset.sizeGuideBound === 'true') return;
    container.dataset.sizeGuideBound = 'true';

    // Unit switch (IN / CM)
    const unitSwitch = container.querySelector('[data-unit-switch]');
    if (unitSwitch) {
      unitSwitch.addEventListener('click', () => {
        const isCm = container.getAttribute('data-unit') === 'cm';
        const nextUnit = isCm ? 'in' : 'cm';
        container.setAttribute('data-unit', nextUnit);
        unitSwitch.setAttribute('aria-checked', nextUnit === 'cm' ? 'true' : 'false');
      });
    }

    // Tabs (Product Measurements / Body Measurements)
    const tabs = container.querySelectorAll('[data-sg-tab]');
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const view = tab.getAttribute('data-sg-tab');
        container.setAttribute('data-sg-view', view);
        tabs.forEach((t) => t.classList.toggle('is-active', t === tab));
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', initSizeGuideControls);
initSizeGuideControls();
